import { render, staticRenderFns } from "./error-tips.vue?vue&type=template&id=4c5004ac&scoped=true&"
import script from "./error-tips.vue?vue&type=script&lang=js&"
export * from "./error-tips.vue?vue&type=script&lang=js&"
import style0 from "./error-tips.vue?vue&type=style&index=0&id=4c5004ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5004ac",
  null
  
)

export default component.exports